import store from '../store/Store';
import loc, { format } from 'owa-localize';
import getExpirationDate from './getExpirationDate';
import {
    bookWithMeCopyLinkExpirationDetail,
    bookWithMeSingleUseLinkExpirationNounType,
    bookWithMeLinkExpirationNounType,
} from '../components/shared/ShareModal.locstring.json';

// function that will return the working for the
// expiring date,  for example
// This link will expire on: {date}
export function getExpiringDateDetail(): string {
    let expiringDateDetail;
    if (store.sharedViewState.isPrivate) {
        // Add to the wording the link type (link or single use link)
        expiringDateDetail = format(
            loc(bookWithMeCopyLinkExpirationDetail),
            store.sharedViewState.isSingleUse
                ? loc(bookWithMeSingleUseLinkExpirationNounType)
                : loc(bookWithMeLinkExpirationNounType),
            getExpirationDate() as string
        );
    }
    return expiringDateDetail as string;
}
